<h2 mat-dialog-title>{{ data.title || 'Add FTP User' }}</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Username"
      placeholder="Type username"
      formControlName="username"
      type="text"
      [suffixText]="'.ftp@' + data.domain"
    ></app-input-field>

    <app-input-field
      label="Password"
      placeholder="Password"
      formControlName="password"
      type="password"
      autocomplete="new-password"
    ></app-input-field>

    <app-input-field
      label="Directory access"
      placeholder="wp-content"
      formControlName="homeDir"
      type="text"
      hint="Leave blank for public_html access"
      [prefixText]="data.domain"
    ></app-input-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">
    {{ data.primaryButtonText || 'Add FTP User' }}
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
